import AssignmentRequest from '@/services/assignment_request'

const acceptRequest = async ({ commit }, id) => {
  return new Promise(async (resolve, reject) => {
    AssignmentRequest.accept(id).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}

const rejectRequest = async ({ commit }, id) => {
  return new Promise(async (resolve, reject) => {
    AssignmentRequest.reject(id).then((response) => {
      resolve(response)
    }).catch((error) => {
      reject(error)
    })
  })
}
export default {
  acceptRequest,
  rejectRequest
}



// WEBPACK FOOTER //
// ./src/features/payer/assignment_requests/store/actions.js